const isString = (value) => typeof value === 'string';

export { isString };
//# sourceMappingURL=isString.js.map
